import * as React from "react"



type saInterfacesIcons = {
  name?: string
}

// @ts-ignore
let SaIcons: React.FC<saInterfacesIcons> = ({ name }) => {

  // leftArrow
  // rightArrow


  switch (name){
    case 'leftArrow':
      return <svg xmlns="http://www.w3.org/2000/svg" width="30" height="14" viewBox="0 0 30 14"><g id="left-arrow" transform="translate(0)"><g id="sgry_17" data-name="sgry 17" transform="translate(0)"><path id="kont_1188" data-name="kont 1188" d="M28.828,137.871H4.01l4.111-3.942a1.1,1.1,0,0,0,0-1.6,1.2,1.2,0,0,0-1.657,0L.344,138.2h0a1.1,1.1,0,0,0,0,1.6h0l6.123,5.871a1.2,1.2,0,0,0,1.657,0,1.1,1.1,0,0,0,0-1.6L4.01,140.129H28.828a1.13,1.13,0,1,0,0-2.258Z" transform="translate(0 -132)" fill="#3e4348"/></g></g></svg>
    case 'rightArrow':
      return <svg xmlns="http://www.w3.org/2000/svg" width="30" height="14" viewBox="0 0 30 14"><path id="cont_1188" data-name="cont 1188" d="M1.171,137.871H25.989l-4.111-3.942a1.1,1.1,0,0,1,0-1.6,1.2,1.2,0,0,1,1.657,0l6.123,5.871h0a1.1,1.1,0,0,1,0,1.6h0l-6.123,5.871a1.2,1.2,0,0,1-1.657,0,1.1,1.1,0,0,1,0-1.6l4.111-3.942H1.171a1.13,1.13,0,1,1,0-2.258Z" transform="translate(0 -132)" fill="#3e4348"/></svg>
    default:
      return ''
  }


  return ''
}

export default SaIcons